module.exports = __webpack_public_path__ + "static/media/bairdholm.2aad92c8.png";